import MockAdapter from 'axios-mock-adapter'
import React, {useState} from 'react'
import {UserModel} from '../models/UserModel'
import {Link} from 'react-router-dom'
import config from '../../../../config.json'
//import Log from '../../../../guiLogs/logs/Log'
import {encryptData} from './../components/util';
import {
  LOGIN_URL,
  GET_USER_BY_ACCESSTOKEN_URL,
  REGISTER_URL,
  REQUEST_PASSWORD_URL,
} from '../redux/AuthCRUD'
import {UsersTableMock} from './usersTableMock'

export function mockAuth(mock: MockAdapter) {
   mock.onPost(LOGIN_URL).reply(async ({ data }) => {
    var clientId = '',appNo='',dymcSndrId='',senderID='',deferedFlag='',fileMgmtSupportFlag='',ccEmail='',smsInbox='',smsOutbox='',otpsent='',clientStatus='',twoStepAuth='',cannedMsgSupport='',addressBookSupport='',alertMobileNum='',expiryMin='',differedDaysLimit='',mfaMode='',jwtToken='',dsrSupport='';
    const { username, password } = JSON.parse(data);
    const salt = process.env.SALT || '6d090796-ecdf-11ea-adc1-0242ac112345';
    if (username && password) {
      try {
       // const response = await fetch(`${config.apiUrl}/bmpportal/getClientInfo?Username=${username}&Password=${password}`);
       const basicAuth = 'Basic ' + btoa(`${config.API_USERNAME}:${config.API_PASSWORD}`);
       const response = await fetch(`${config.apiUrl}/bmpportal/getClientInfo`, {
        method: 'POST',    
        headers: {
          'Authorization': basicAuth,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: username,
          password: password
        })
      });
      //Log('mockAuth','URL',`${config.apiUrl}/bmpportal/getClientInfo`)
     // console.log("response from API::::"+response.ok);
       const responseData = await response.json();
    // console.log('mockAuth','Variable',"Response from API::::"+JSON.stringify(responseData))
        if (Array.isArray(responseData) && responseData.length > 0) {
          const firstItem = responseData[0];
          clientId = firstItem.clientId;
          appNo = firstItem.appNo;
          dymcSndrId= firstItem.dymcSndrId;
          senderID = firstItem.sndrId;
          deferedFlag = firstItem.deferedFlag;
          fileMgmtSupportFlag= firstItem.fileMgmtSupport;
	        ccEmail = firstItem.ccEmail;
	        smsInbox = firstItem.smsInbox;
	        smsOutbox = firstItem.smsOutbox;
          otpsent = firstItem.otpsent;
          clientStatus = firstItem.clientStatus;
          twoStepAuth = firstItem.twoStepAuth
          cannedMsgSupport = firstItem.cannedMsgSupport;
          addressBookSupport = firstItem.addressBookSupport;
          alertMobileNum = firstItem.alertMobileNum;
          differedDaysLimit = firstItem.differedDaysLimit;
          mfaMode = firstItem.mfaMode;
          jwtToken = firstItem.jwtToken;
          dsrSupport = firstItem.dsrSupport;
          if(clientStatus == '3' || clientStatus == '2')
          {
            try {
              const response = await fetch(`${config.apiUrl}/bmpportal/getExpireTime?username=${username}`,{
                method: 'GET',    
                headers: {
                  'Authorization': basicAuth,
                },
              });
              if (response.ok) {
                  expiryMin = await response.text();
              } else {
                  
              }
          } catch (error) {
              
          }
          }
          
          const encryptedClientId = encryptData(clientId, salt);
          const encryptedusername = encryptData(username, salt);
          //const encryptedpassword = encryptData(password, salt);
          const encryptedappNo = encryptData(appNo, salt);
          const encrypteddymcSndrId = encryptData(dymcSndrId, salt);
          const encryptedsenderID = encryptData(senderID, salt);
          const encrypteddeferedFlag = encryptData(deferedFlag, salt);
          const encryptedfileMgmtSupportFlag = encryptData(fileMgmtSupportFlag, salt);
          const encryptedccEmail = encryptData(ccEmail, salt);
          const encryptedsmsInbox = encryptData(smsInbox, salt);
          const encryptedsmsOutbox = encryptData(smsOutbox, salt);
          const encryptedsmsotpsent = encryptData(otpsent, salt);
          const encryptedclientStatus = encryptData(clientStatus, salt);
          const encryptedtwoStepAuth = encryptData(twoStepAuth, salt);
          const encryptedcannedMsgSupport = encryptData(cannedMsgSupport, salt);
          const encryptedaddressBookSupport = encryptData(addressBookSupport, salt);
          const encryptedalertMobileNum = encryptData(alertMobileNum, salt);
          const encrypteddifferedDaysLimit = encryptData(differedDaysLimit,salt);
          const encryptedmfaMode = encryptData(mfaMode,salt);
          const encryptedJwtToken = encryptData(jwtToken,salt);
          const encrypteddsrSupport = encryptData(dsrSupport,salt);
          //const encryptedexpiryMin = encryptData(expiryMin,salt) 
         // console.log(":mockAuth:::::clientId::::::"+clientId+":::::::::clientStatus::::::::::::"+clientStatus);
    localStorage.setItem('clientId', encryptedClientId);
    localStorage.setItem('username', encryptedusername);
    //localStorage.setItem('password', encryptedpassword);
    localStorage.setItem('appNo',encryptedappNo);
    localStorage.setItem('dymcSndrId',encrypteddymcSndrId);
    localStorage.setItem('senderID',encryptedsenderID);
    localStorage.setItem('deferedFlag',encrypteddeferedFlag);
    localStorage.setItem('fileMgmtSupportFlag',encryptedfileMgmtSupportFlag);
    localStorage.setItem('ccEmail',encryptedccEmail); 
    localStorage.setItem('smsInbox',encryptedsmsInbox);
    localStorage.setItem('smsOutbox',encryptedsmsOutbox);
    localStorage.setItem('otpsent',encryptedsmsotpsent);
    localStorage.setItem('clientStatus',encryptedclientStatus);
    localStorage.setItem('twoStepAuth',encryptedtwoStepAuth);    
    localStorage.setItem('cannedMsgSupport',encryptedcannedMsgSupport);
    localStorage.setItem('addressBookSupport',encryptedaddressBookSupport);    
    localStorage.setItem('alertMobileNum',encryptedalertMobileNum);
    localStorage.setItem('differedDaysLimit',encrypteddifferedDaysLimit);
    localStorage.setItem('mfaMode',encryptedmfaMode);
    localStorage.setItem('otpResendAttempt',"0");
    localStorage.setItem('paramValue',encryptedJwtToken);
    //alert(expiryMin)
    localStorage.setItem('expiryMin',expiryMin);
    localStorage.setItem('timestamp', Date.now().toString());
    localStorage.setItem('dsrSupport',encrypteddsrSupport);
	   if (clientId && clientStatus=='1' ) {
              const auth = {
              accessToken: 'access-token-8f3ae836da744329a6f93bf20594b5cc',
              refreshToken: 'access-token-f8c137a2c98743f48b643e71161d90aa',
            };
            return [200, { ...auth, password: undefined }];
          }
        } else {
          //console.error('Unexpected or empty API response:', responseData);
        }
      } catch (error) {
        //console.error('Error fetching data:', error);
      }
    }
  
    return [400];
  });
  

  mock.onPost(REGISTER_URL).reply(({data}) => {
    const {email, firstname, lastname, password} = JSON.parse(data)

    if (email && firstname && lastname && password) {
      const user: UserModel = {
        id: generateUserId(),
        email,
        firstname,
        lastname,
        username: `${firstname}-${lastname}`,
        password,
        roles: [2], // Manager
        auth: {
          accessToken: 'access-token-' + Math.random(),
          refreshToken: 'access-token-' + Math.random(),
        },
        pic: process.env.PUBLIC_URL + '/media/users/default.jpg',
      }

      UsersTableMock.table.push(user)
      const auth = user.auth

      return [200, {...auth, password: undefined}]
    }

    return [400]
  })

  mock.onPost(REQUEST_PASSWORD_URL).reply(({data}) => {
    const {email} = JSON.parse(data)

    if (email) {
      const user = UsersTableMock.table.find((x) => x.email.toLowerCase() === email.toLowerCase())
      let result = false
      if (user) {
        user.password = undefined
        result = true
        return [200, {result, password: undefined}]
      }
    }

    return [400]
  })

  mock.onGet(GET_USER_BY_ACCESSTOKEN_URL).reply(({headers: {Authorization}}) => {
    const accessToken =
      Authorization && Authorization.startsWith('Bearer ') && Authorization.slice('Bearer '.length)

    if (accessToken) {
      const user = UsersTableMock.table.find((x) => x.auth?.accessToken === accessToken)

      if (user) {
        return [200, {...user, password: undefined}]
      }
    }

    return [401]
  })

  function generateUserId(): number {
    const ids = UsersTableMock.table.map((el) => el.id)
    const maxId = Math.max(...ids)
    return maxId + 1
  }
}

